<script>
export default {
  install(Vue, impl) {
    Vue.$bundle = function (source, defaultBundle, readyFunc) {
      if (typeof impl === "function") {
        impl(source, Object.keys(defaultBundle), function (bundle) {
          readyFunc({...defaultBundle, ...bundle})
        });
      } else {
        throw "'Options' for this plugin should be a function."
      }
    }
  }
}
</script>
